export const name = 're-core-page-shop-buy-gift-card'
export const component = 're-buy-giftcard'

import {factory} from '../../../../../lib/page'

const props = {
  terms: {},
  item: {},
  token: {}
}

export default factory(name, {props, component})
